<template>
  <new-route />
</template>

<script>
import NewRoute from "@/components/3pl/Settings/RoutesAndVehicles/Routes/TerminalToTerminal/NewRoute/index";
export default {
  components: {
    NewRoute,
  },
};
</script>

<style></style>
